import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { ResponsiveLogo } from "@silvertours/front-entities";
import { Theme } from "@silvertours/front-shared";
import React, { useEffect } from "react";
import { useMedia } from "react-use";
import { HiddenLinksPopover, MobileMenu, Navigation } from "./components";
import { Header as StyledHeader, IconButtonContainer, ActionArea, DesktopActions, ActionButtons } from "./Header.styles";
import { useMobileMenus } from "./hooks";
var Header = function(_param) {
    var children = _param.children, desktopActions = _param.desktopActions, desktopLinks = _param.desktopLinks, mobileMenus = _param.mobileMenus, rest = _object_without_properties(_param, [
        "children",
        "desktopActions",
        "desktopLinks",
        "mobileMenus"
    ]);
    var ref = useMobileMenus(), openMenu = ref.openMenu, setOpenMenu = ref.setOpenMenu;
    var actionAreaRef = React.useRef(null);
    var ref1 = _sliced_to_array(React.useState(null), 2), menuTop = ref1[0], setMenuTop = ref1[1];
    var positionMenu = function() {
        if (actionAreaRef.current) {
            var bottom = actionAreaRef.current.getBoundingClientRect().bottom;
            setMenuTop(bottom);
        }
    };
    useEffect(function() {
        positionMenu();
        window.addEventListener("resize", positionMenu);
        return function() {
            window.removeEventListener("resize", positionMenu);
        };
    }, [
        actionAreaRef,
        mobileMenus
    ]);
    var ref2 = _sliced_to_array(React.useState([]), 2), hiddenLinks = ref2[0], setHiddenLinks = ref2[1];
    var getHiddenLinks = function(links) {
        setHiddenLinks(links);
    };
    var wideViewPort = useMedia("(min-width:".concat(Theme.getBreakpoint("lg"), "px)"), true);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            children,
            /*#__PURE__*/ _jsxs(StyledHeader, _object_spread_props(_object_spread({}, rest), {
                ref: actionAreaRef,
                children: [
                    /*#__PURE__*/ _jsx(ResponsiveLogo, {}),
                    /*#__PURE__*/ _jsx(ActionArea, {
                        children: wideViewPort ? /*#__PURE__*/ _jsxs(DesktopActions, {
                            children: [
                                /*#__PURE__*/ _jsx(Navigation, {
                                    mode: "desktop",
                                    links: desktopLinks,
                                    getHiddenElements: getHiddenLinks
                                }),
                                /*#__PURE__*/ _jsxs(ActionButtons, {
                                    children: [
                                        desktopActions.map(function(param) {
                                            var component = param.component, key = param.key, hide = param.hide;
                                            return hide ? null : /*#__PURE__*/ _jsx(IconButtonContainer, {
                                                children: component
                                            }, "actionButton-".concat(key));
                                        }),
                                        Boolean(hiddenLinks.length) && /*#__PURE__*/ _jsx(HiddenLinksPopover, {
                                            children: hiddenLinks
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx(ActionButtons, {
                            id: "header-action-buttons",
                            children: mobileMenus.map(function(param, index) {
                                var id = param.id, closeLabel = param.closeLabel, content = param.content, hide = param.hide, icon = param.icon, iconLabel = param.iconLabel, onClose = param.onClose;
                                var handleMenuClick = function() {
                                    setOpenMenu(index);
                                };
                                return hide ? null : /*#__PURE__*/ _jsx(MobileMenu, {
                                    id: id,
                                    closeMenuLabel: closeLabel,
                                    renderContent: content,
                                    icon: icon,
                                    iconLabel: iconLabel,
                                    toggleOpen: handleMenuClick,
                                    open: openMenu === index,
                                    onClose: onClose,
                                    topPosition: menuTop
                                }, iconLabel);
                            })
                        })
                    })
                ]
            }))
        ]
    });
};
export { Header };
